import dummyTripRateAnalysisResponse from "./dummyData";
import { TRIP_TYPES, isAirportPickup } from "./utils";

const SIMULATED_DELAY_MS = 1200;

/**
 * Trip.com rate analysis search (dummy).
 * Replace with real Trip.com API integration later.
 */
export const searchTripRateAnalysis = (params) =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      if (!params?.pickup?.name || !params?.dropoff?.name) {
        reject(new Error("Pickup and drop-off locations are required."));
        return;
      }

      if (isAirportPickup(params.tripType)) {
        if (!params?.flightNumber?.trim()) {
          reject(new Error("Flight number is required."));
          return;
        }

        if (!params?.date) {
          reject(new Error("Pickup date is required."));
          return;
        }
      } else if (!params?.dateTime) {
        reject(new Error("Pickup date & time is required."));
        return;
      }

      const baseData = dummyTripRateAnalysisResponse.data;
      const flightNo = params.flightNumber?.trim().toUpperCase() || "VS7012";
      const scheduleDate =
        params.date || params.dateTime?.split("T")[0] || "2026-06-16";

      resolve({
        data: {
          ...baseData,
          flightDetails: isAirportPickup(params.tripType)
            ? {
                ...baseData.flightDetails,
                flightNo,
                stnId: `${flightNo},${scheduleDate},INV,AMS`,
                flights: (baseData.flightDetails.flights || []).map(
                  (flight) => ({
                    ...flight,
                    stnno: flightNo,
                    stnid: `${flightNo},${scheduleDate},INV,AMS`,
                  })
                ),
              }
            : null,
        },
      });
    }, SIMULATED_DELAY_MS);
  });
